// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O8mJw","toggleWrap":"styles_toggleWrap__fjfa_","content":"styles_content__20Yd9","selectAreaCode":"styles_selectAreaCode__1hqDS"};